import { backOff, BackoffOptions } from "exponential-backoff";

export function withBackoff(action: any, options?: BackoffOptions): any {
  return backOff(action, {
    numOfAttempts: 3,
    startingDelay: 1_000,
    delayFirstAttempt: false,
    ...options,
  });
}
